export enum TRegularPlayEvents {
  BACK = 'BACK',
  BACK_TO_IDEL = 'BACK_TO_IDEL',
  BACK_TO_FAKE_FIELD_GOAL = 'BACK_TO_FAKE_FIELD_GOAL',
  BACK_TO_FAKE_PUNT = 'BACK_TO_FAKE_PUNT',
  ON_PASS_SELECTED = 'ON_PASS_SELECTED',
  ON_RESULT_SELECTED = 'ON_RESULT_SELECTED',
  REF_EVENT = 'REF_EVENT',
  FUMBLE = 'FUMBLE',
  ON_TOV = 'ON_TOV',
  FUMBLE_RECOVERY = 'FUMBLE_RECOVERY',
  BACK_TO_PASS_RESULT = 'BACK_TO_PASS_RESULT',
  BACK_TO_FUMBLE_RECOVERY = 'BACK_TO_FUMBLE_RECOVERY',
  BACK_TO_PLAY_DESIGN = 'BACK_TO_PLAY_DESIGN',
  ON_PENALTY = 'ON_PENALTY',
  BACK_TO_COIN_TOSS = 'BACK_TO_COIN_TOSS',
  ON_POSSESSION_SELECT = 'ON_POSSESSION_SELECT',
  TO_YARDAGE = 'TO_YARDAGE',
  TO_DRIVE_SELECT = 'TO_DRIVE_SELECT',
  BACK_TO_SELECT_POSSESSION = 'BACK_TO_SELECT_POSSESSION',
  BACK_TO_SELECT_DRIVE = 'BACK_TO_SELECT_DRIVE',
}

export enum TRegularPlayStates {
  SELECT_PLAY_DESIGN = 'SELECT_PLAY_DESIGN',
  SELECT_PASS_RESULT = 'SELECT_PASS_RESULT',
  SELECT_YARDAGE = 'SELECT_YARDAGE',
  SELECT_FUMBLE_RECOVERY = 'SELECT_FUMBLE_RECOVERY',
  SELECT_TOV = 'SELECT_TOV',
  SELECT_PASS_RESULT_TOV = 'SELECT_PASS_RESULT_TOV',
  REF_EVENT = 'REF_EVENT',
  HANDLE_YARDAGE_TOGGLES = 'HANDLE_YARDAGE_TOGGLES',
  CONFIRMATION = 'CONFIRMATION',
  SELECT_POSSESSION = 'SELECT_POSSESSION',
  SELECT_DRIVE = 'SELECT_DRIVE',
}
